import {useEffect, useState} from "react";
import {findCustomerFiltersWithPagination} from "../api/customerApiClient";

export const useCustomerFilters = (page, pageSize, filterFromDate, reloadTrigger) => {
    const [customerFilters, setCustomerFilters] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const customerFiltersWithPagination = findCustomerFiltersWithPagination(page, pageSize, filterFromDate, abortController.signal);

        customerFiltersWithPagination
            .then(
                (data) => {
                    const customerFilters = data.customerFilters;
                    const pagination = data.pagination;

                    setCustomerFilters(customerFilters)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, filterFromDate, reloadTrigger]);

    return {customerFilters : customerFilters, pagination};
};